import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import {
    MatDialogModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    MatSortModule,
    MatIconModule,
    MatMenuModule,
    MatTableModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule
} from '@angular/material';
import { LessonsListComponent } from './lessons-list.component';
import { SvgIconModule } from '@app/core/components/svg-icon/svg-icon.module';
import { PaginationModule } from '@app/shared/components/pagination/pagination.module';
import { RouterModule } from '@angular/router';
import { TeacherService } from '@app/teacher/services/teacher.service';
import { LessonsListService } from '@app/teacher/components/lessons-list/lessons-list.service';
import { LessonsListHeaderComponent } from '@app/teacher/components/lessons-list/lessons-list-header/lessons-list-header.component';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        PaginationModule,
        MatTableModule,
        MatIconModule,
        MatMenuModule,
        MatSortModule,
        MatButtonModule,
        MatDialogModule,
        MatProgressSpinnerModule,
        SvgIconModule,
        MatPaginatorModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule
    ],
    providers: [DatePipe, TeacherService, LessonsListService],
    declarations: [LessonsListComponent, LessonsListHeaderComponent],
    exports: [LessonsListComponent]
})
export class LessonsListModule {}
